Groupon.qualtrics = function(e, h, f, g) {
  this.get = function(a) {
    var b, c, d, e1;
    a = a + '=';
    c = document.cookie.split(';');
    b = 0;
    e1 = c.length;
    while (b < e1) {
      d = c[b];
      while (' ' === d.charAt(0)) {
        d = d.substring(1, d.length);
      }
      if (0 === d.indexOf(a)) {
        return d.substring(a.length, d.length);
      }
      b++;
    }
    return null;
  };
  this.set = function(a, c) {
    var b;
    b = new Date;
    b.setTime(b.getTime() + 6048e5);
    b = '; expires=' + b.toGMTString();
    document.cookie = a + '=' + c + b + '; path=/; ';
  };
  this.check = function() {
    var a, c;
    a = this.get(f);
    if (a) {
      a = a.split(':');
    } else if (100 !== e) {
      'v' === h && (e = Math.random() >= e / 100 ? 0 : 100);
      a = [h, e, 0];
      this.set(f, a.join(':'));
    } else {
      return !0;
    }
    c = a[1];
    if (100 === c) {
      return !0;
    }
    switch (a[0]) {
      case 'v':
        return !1;
      case 'r':
        return c = a[2] % Math.floor(100 / c);
        a[2]++;
        this.set(f, a.join(':'));
        !c;
    }
    return !0;
  };
  this.go = function() {
    var a;
    if (this.check()) {
      a = document.createElement('script');
      a.type = 'text/javascript';
      a.src = g + '&t=' + (new Date).getTime();
      document.body && document.body.appendChild(a);
    }
  };
  this.start = function() {
    var a;
    a = this;
    if (window.addEventListener) {
      window.addEventListener('load', (function() {
        a.go();
      }), !1);
    } else {
      window.attachEvent && window.attachEvent('onload', (function() {
        a.go();
      }));
    }
  };
};

//# sourceMappingURL=data:application/json;base64,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
